Groupon.qualtrics = function(e, h, f, g) {
  this.get = function(a) {
    var b, c, d, e1;
    a = a + '=';
    c = document.cookie.split(';');
    b = 0;
    e1 = c.length;
    while (b < e1) {
      d = c[b];
      while (' ' === d.charAt(0)) {
        d = d.substring(1, d.length);
      }
      if (0 === d.indexOf(a)) {
        return d.substring(a.length, d.length);
      }
      b++;
    }
    return null;
  };
  this.set = function(a, c) {
    var b;
    b = new Date;
    b.setTime(b.getTime() + 6048e5);
    b = '; expires=' + b.toGMTString();
    document.cookie = a + '=' + c + b + '; path=/; ';
  };
  this.check = function() {
    var a, c;
    a = this.get(f);
    if (a) {
      a = a.split(':');
    } else if (100 !== e) {
      'v' === h && (e = Math.random() >= e / 100 ? 0 : 100);
      a = [h, e, 0];
      this.set(f, a.join(':'));
    } else {
      return !0;
    }
    c = a[1];
    if (100 === c) {
      return !0;
    }
    switch (a[0]) {
      case 'v':
        return !1;
      case 'r':
        return c = a[2] % Math.floor(100 / c);
        a[2]++;
        this.set(f, a.join(':'));
        !c;
    }
    return !0;
  };
  this.go = function() {
    var a;
    if (this.check()) {
      a = document.createElement('script');
      a.type = 'text/javascript';
      a.src = g + '&t=' + (new Date).getTime();
      document.body && document.body.appendChild(a);
    }
  };
  this.start = function() {
    var a;
    a = this;
    if (window.addEventListener) {
      window.addEventListener('load', (function() {
        a.go();
      }), !1);
    } else {
      window.attachEvent && window.attachEvent('onload', (function() {
        a.go();
      }));
    }
  };
};

//# sourceMappingURL=data:application/json;base64,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
